Groupon.qualtrics = function(e, h, f, g) {
  this.get = function(a) {
    var b, c, d, e1;
    a = a + '=';
    c = document.cookie.split(';');
    b = 0;
    e1 = c.length;
    while (b < e1) {
      d = c[b];
      while (' ' === d.charAt(0)) {
        d = d.substring(1, d.length);
      }
      if (0 === d.indexOf(a)) {
        return d.substring(a.length, d.length);
      }
      b++;
    }
    return null;
  };
  this.set = function(a, c) {
    var b;
    b = new Date;
    b.setTime(b.getTime() + 6048e5);
    b = '; expires=' + b.toGMTString();
    document.cookie = a + '=' + c + b + '; path=/; ';
  };
  this.check = function() {
    var a, c;
    a = this.get(f);
    if (a) {
      a = a.split(':');
    } else if (100 !== e) {
      'v' === h && (e = Math.random() >= e / 100 ? 0 : 100);
      a = [h, e, 0];
      this.set(f, a.join(':'));
    } else {
      return !0;
    }
    c = a[1];
    if (100 === c) {
      return !0;
    }
    switch (a[0]) {
      case 'v':
        return !1;
      case 'r':
        return c = a[2] % Math.floor(100 / c);
        a[2]++;
        this.set(f, a.join(':'));
        !c;
    }
    return !0;
  };
  this.go = function() {
    var a;
    if (this.check()) {
      a = document.createElement('script');
      a.type = 'text/javascript';
      a.src = g + '&t=' + (new Date).getTime();
      document.body && document.body.appendChild(a);
    }
  };
  this.start = function() {
    var a;
    a = this;
    if (window.addEventListener) {
      window.addEventListener('load', (function() {
        a.go();
      }), !1);
    } else {
      window.attachEvent && window.attachEvent('onload', (function() {
        a.go();
      }));
    }
  };
};

//# sourceMappingURL=data:application/json;base64,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
